import { useEffect, useMemo, useState } from 'react';

import type { FeatureCollection } from 'geojson';

import { useAppSelector } from '@/hooks/useAppSelector';
import type { EnhancedFloodPoint } from '@/types/flood.types';

import { enhancedFloodPointsFromDemoRegionGeoJson } from '../utils/floodDemoRegionGeojson';
import { loadMergedFloodRegionGeoJson } from '../utils/loadMergedFloodRegionGeoJson';

/**
 * Fetch GeoJSON vùng ngập (gộp Hà Nội + toàn quốc); sinh điểm ngập đồng bộ (centroid + mẫu trong polygon).
 */
export function useHanoiFloodDemoGeoJson(): {
  floodGeoJson: FeatureCollection | null;
  floodPoints: EnhancedFloodPoint[];
} {
  const analysisYear = useAppSelector((s) => s.map.geeParams.year);
  const referenceDateIso = useAppSelector((s) => s.scenario.selectedDate);
  const [floodGeoJson, setFloodGeoJson] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    loadMergedFloodRegionGeoJson(controller.signal)
      .then(setFloodGeoJson)
      .catch(() => setFloodGeoJson(null));
    return () => controller.abort();
  }, []);

  const floodPoints = useMemo(
    () =>
      enhancedFloodPointsFromDemoRegionGeoJson(floodGeoJson ?? undefined, {
        scenarioYear: analysisYear,
        extraSamplesPerPolygon: 6,
        referenceDateIso,
      }),
    [floodGeoJson, analysisYear, referenceDateIso],
  );

  return { floodGeoJson, floodPoints };
}
